import React from "react";
import { useTranslation } from "react-i18next";
import smartSwitch from "assets/img/smartSwitch.png";

const Step1 = React.forwardRef((props, ref) => {
  const { t } = useTranslation('wizard');
  const isValidated = () => {
      return true;
  };
  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));
  return (
    <>
      <div className="info-text c-white">
        {t('switches.step1Body')}
      </div>
      <div className="text-center">
        <img src={smartSwitch} alt="smart-switch" />
      </div>
    </>
  );
});

export default Step1;
